module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b46e0ae877de42554ae321fb4e9ce420.png";